import React, { useState } from 'react';
import styled from 'styled-components';

import DefaultLogoPath from '../../image/DefaultLogo.png';
import { ReactComponent as TrashIcon } from '../../image/Delete(stroke).svg';

export default function LogoView(props) {
  const { data, index, onClickDeleteButton } = props;

  const [isErrorProfile, setIsErrorProfile] = useState(false);

  function decideUserProfile() {
    if (isErrorProfile || !data) return DefaultLogoPath;
    return data;
  }

  function onClickDelete(e) {
    e.stopPropagation();
    onClickDeleteButton(index);
  }

  return (
    <TopLevelWrapper>
      <Picture src={decideUserProfile()} onError={() => setIsErrorProfile(true)} />
      <DeleteButton onClick={onClickDelete}>
        <TrashIcon />
      </DeleteButton>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 123px;
  height: 123px;

  border-radius: 5px;
  overflow: hidden;
`;

const Picture = styled.img`
  position: absolute;

  inset: 0;

  width: 100%;
  height: 100%;

  border-radius: 5px;

  object-fit: cover;
  pointer-events: none;
`;

const DeleteButton = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 25px;
  height: 25px;

  padding: 5px;
  box-sizing: border-box;

  border-bottom-left-radius: 5px;
  background-color: ${props => props.theme.whiteAlpha20};

  transition: background-color 0.2s ease-in-out;

  & svg {
    width: 14px;
    height: 14px;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRedAlpha20};
    }
  }
`;
